import InlineText from '../../InlineEdit/InlineText';
import InlineTextArea from '../../InlineEdit/InlineTextArea';
import './intro.scss';

const DEFAULTS = {
  eyebrow: 'Notre maison',
  heading: 'Une table de quartier, pensée comme un dimanche en famille.',
  body: `À Ciel Ouvert, on cuisine la France traditionnelle — ris de veau et truffe, magret de canard aux fruits rouges, tarte tatin flambée au calvados — avec les produits que nous livrent chaque matin les maraîchers, pêcheurs et éleveurs du Brabant wallon et de Wallonie picarde.

Notre carte tient sur une page, change avec les arrivages, et nos lunchs changent chaque semaine au gré du marché. Rien d’élaboré pour le plaisir d’élaborer : ce que vous trouvez dans l’assiette est du fait maison, dans une salle baignée de jour.

Il nous arrive de manquer d’un produit — nous vous proposons alors une autre alternative, et nous vous remercions de votre compréhension.`,
  signature: "— L'équipe d'À Ciel Ouvert",
};

const View = (props: any) => {
  const { data, isEditMode, block, onChangeBlock } = props;

  const update = (field: string, value: string) =>
    onChangeBlock(block, { ...data, [field]: value });

  const eyebrow = data.eyebrow ?? (isEditMode ? '' : DEFAULTS.eyebrow);
  const heading = data.heading ?? (isEditMode ? '' : DEFAULTS.heading);
  const body = data.body ?? (isEditMode ? '' : DEFAULTS.body);
  const signature = data.signature ?? (isEditMode ? '' : DEFAULTS.signature);

  return (
    <section className="intro">
      <div className="shell">
        <div className="intro-grid">
          <div>
            <p className="eyebrow">
              {isEditMode ? (
                <InlineText
                  value={eyebrow}
                  onChange={(v) => update('eyebrow', v)}
                  renderTag="span"
                  placeholder="Sur-titre"
                />
              ) : (
                eyebrow
              )}
            </p>
            <h2>
              {isEditMode ? (
                <InlineText
                  value={heading}
                  onChange={(v) => update('heading', v)}
                  renderTag="span"
                  placeholder="Titre de l'introduction"
                />
              ) : (
                heading
              )}
            </h2>
          </div>
          <div>
            {isEditMode ? (
              <InlineTextArea
                value={body}
                onChange={(v) => update('body', v)}
                renderTag="div"
                renderClassName="intro-body-editor"
                placeholder="Texte d'introduction. Sautez une ligne pour créer un nouveau paragraphe."
              />
            ) : body ? (
              body.split('\n').map((paragraph: string, i: number) => (
                <p key={i} className={i === 0 ? 'lead' : undefined}>
                  {paragraph}
                </p>
              ))
            ) : (
              <>
                <p className="lead">
                  À Ciel Ouvert, on cuisine la France traditionnelle&nbsp;— ris
                  de veau et truffe, magret de canard aux fruits rouges, tarte
                  tatin flambée au calvados&nbsp;— avec les produits que nous
                  livrent chaque matin les maraîchers, pêcheurs et éleveurs du
                  Brabant wallon et de Wallonie picarde.
                </p>
                <p>
                  Notre carte tient sur une page, change avec les arrivages, et
                  nos lunchs changent chaque semaine au gré du marché. Rien
                  d&rsquo;élaboré pour le plaisir d&rsquo;élaborer&nbsp;: ce que
                  vous trouvez dans l&rsquo;assiette est du <em>fait maison</em>
                  , dans une salle baignée de jour.
                </p>
                <p>
                  Il nous arrive de manquer d&rsquo;un produit&nbsp;— nous vous
                  proposons alors une autre alternative, et nous vous remercions
                  de votre compréhension.
                </p>
              </>
            )}
            {(isEditMode || signature) && (
              <p className="signature">
                {isEditMode ? (
                  <InlineText
                    value={signature}
                    onChange={(v) => update('signature', v)}
                    renderTag="span"
                    placeholder="Signature"
                  />
                ) : (
                  signature
                )}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default View;
